import { Layout } from "antd";
import { useTranslation } from "react-i18next";

import BaseHeader from "@/components/Header/BaseHeader";
import UsersTable from "@/components/ListTable/UsersTable";
import { STORAGE_KEYS } from "@/constants/StorageKeys";
import { USERS_INCLUDES } from "@/entities/users";
import { ListProvider } from "@/modules/list";
import UserAddButton from "@/modules/user/user-add-button";

const { Content } = Layout;

const Users = () => {
  const { t } = useTranslation();

  return (
    <>
      <BaseHeader
        title={t("navigation:users")}
        extra={[<UserAddButton key="user-add-button" />]}
      />
      <Content>
        <ListProvider
          endpoint="users"
          storageKey={STORAGE_KEYS.USERS}
          includes={[USERS_INCLUDES.ORGANIZATION, USERS_INCLUDES.ROLES]}
        >
          <UsersTable />
        </ListProvider>
      </Content>
    </>
  );
};

export default Users;
